'use client';

import { LiveUpdateContext, useLiveUpdate } from '@/components/contexts/live-updates';
import { useUserSessionContext } from '@/components/contexts/user-context';
import type { User } from '@/data/types/user';
import type { ReactNode } from 'react';

export function SessionLiveUpdates({ children }: { children: ReactNode; }) {
    const { user } = useUserSessionContext();
    return (
        <LiveUpdateContext enabled={Boolean(user)}>
            {user && <UserLiveSync key={user._id} user={user} />}
            {children}
        </LiveUpdateContext>
    );
}

function UserLiveSync({ user }: { user: User; }) {
    const { updateUser } = useUserSessionContext();

    useLiveUpdate('user', { _id: user._id }, message => {
        if (message.op === 'delete') {
            updateUser(undefined);
            return;
        }
        if (!message.data || message.data._id !== user._id) return;
        updateUser(current => current ? { ...current, ...message.data } : current);
    }, [user._id]);

    return null;
}
